export default {"src":"/_next/static/media/sync_user_rays.b6b76ac8.svg","height":116,"width":133,"blurWidth":0,"blurHeight":0};